
const defaultCommunicateForm = {
    message_body: 'Buenos días equipo...',
    message_title: '',
    receivers: [],
    priority: 'LOW',
}

export default defaultCommunicateForm;
